<script>
import { mapActions } from "vuex";
import loginForm from "./auth/loginForm.vue";
import registerForm from "./auth/registerForm.vue";
import passwordRecoverForm from "./auth/passwordRecoverForm.vue";
export default {
    data: () => ({
        formType: "login"
    }),
    components: {
        loginForm,
        registerForm,
        passwordRecoverForm
    }
};
</script>

<template>
    <div class="content__singin overlay active overlay--auth backdrop-blur">
        <div class="wrapper-lightbox">
            <div class="close-modal" @click="$emit('close')">
                <span class="tx-dark-ad">
                    <i class="fas fa-times"></i>
                </span>
            </div>
            <loginForm
                v-show="formType === 'login'"
                @register="formType = 'register'"
                @recover="formType = 'recover'"
                @close="$emit('close')"
            ></loginForm>
            <registerForm
                v-show="formType === 'register'"
                @login="formType = 'login'"
                @close="$emit('close')"
            ></registerForm>
            <passwordRecoverForm
                v-show="formType === 'recover'"
                @login="formType = 'login'"
                @close="$emit('close')"
            ></passwordRecoverForm>
        </div>
    </div>
</template>
